import Swal from 'sweetalert2'

export function useAlert() {
    async function showAlert(message, config = {}) {
        await Swal.fire({
            title: message,
            timer: 3000,
            ...config
        })
    }

    async function confirm(message, config = {}) {
        const didConfirm = await Swal.fire({
            title: message,
            icon: 'question',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            ...config
        })
        
        if (didConfirm.isConfirmed) {
            return true
        }
    }

    return { showAlert, confirm }
}